import { FileImageOutlined, FilePdfOutlined, FileTextOutlined, FileWordOutlined } from '@ant-design/icons';
import React from 'react';

const getFileIcon = (fileName: string) => {
  if(fileName == undefined) return null;

  if (fileName.match(/\.(pdf)$/i))
    return <FilePdfOutlined style={{ fontSize: 45, color: "#a368fc" }} />;
  if (fileName.match(/\.(docx|doc)$/i))
    return <FileWordOutlined style={{ fontSize: 45, color: "#a368fc" }} />;
  if (fileName.match(/\.(jpg|jpeg|png)$/i))
    return <FileImageOutlined style={{ fontSize: 45, color: "#a368fc" }} />;

  return <FileTextOutlined style={{ fontSize: 45, color: "#a368fc" }} />;
};

export default getFileIcon;